/**
 * iPhones zoom inputs if the font size is 16px unless zooming is prevented by the viewport meta tag. This event handler temporarily overrides the viewport meta to prevent the zooming.
 */

export default function() {
  const maxScale = ",maximum-scale=";
  const maxScaleRegex = /,*maximum-scale=\d*\.*\d*/;
  const viewport = document.querySelector('meta[name="viewport"]');
  const content = viewport.content;

  const lockViewport = state => {
    // http://nerd.vasilis.nl/prevent-ios-from-zooming-onfocus/
    viewport.content =
      content +
      (state === false
        ? content.match(maxScaleRegex, "")
          ? ""
          : maxScale + 10
        : maxScale + 1);
  };

  lockViewport(true);
  setTimeout(function() {
    lockViewport(false);
  }, 1000);
}
